import React from 'react';
import { CollectionsUIProvider } from './context/CollectionsUIContext';
import CollectionsHeader from './CollectionsHeader';
import { Box, Card } from '@mui/material';
import ProductsDropMenu from '../../products/ProductsDropMenu';
import CollectionsTable from './table/CollectionsTable';

export default function Collections () {
    return (
        <CollectionsUIProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' width='100%' marginRight={'2rem'}>
                <Box style={{ borderRadius: '4px', marginTop: '1rem', width: '100%', margin: '1rem 1rem 0 1rem' }}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <CollectionsHeader />
                    </Card>
                </Box>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ProductsDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <CollectionsTable />
                    </div>
                </div>
            </Box>
        </CollectionsUIProvider>
    );
}
